<!-- eslint-disable @angular-eslint/template/no-distracting-elements -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="main_wp prefrences_wp" [ngClass]="{ active_prefrences: prefrencesValue === true }">
  <div class="title">
    <h2 class="top_0">{{ 'Preferences' | translate }}</h2>

    <i class="pi pi-angle-right" (click)="hidePreferncesNext()"></i>
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ul formArrayName="preferences">
      @if (canEditPreferences) {
        <li class="clickable-row" (click)="handleSaveForFutureClick($event)">
          <p>{{ 'SaveForFuture' | translate }}</p>
          <p-inputSwitch
            [(ngModel)]="save_preferences"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="formDisabled" />
        </li>
      }
      @for (data of preferencesArray.controls; track $index; let index = $index) {
        <li
          [formGroupName]="index"
          #liRef
          class="clickable-row"
          (click)="handleRowClick($event, index, op, liRef)">
          <p>
            @if (prefrences[index].name.length > 15) {
              <marquee>
                {{ prefrences[index].name }}
              </marquee>
            } @else {
              <p>
                {{ prefrences[index].name }}
              </p>
            }
          </p>
          @if (prefrences[index].type === 'toggle') {
            <p-inputSwitch formControlName="bool_value" [disabled]="formDisabled"></p-inputSwitch>
          } @else if (prefrences[index].type === 'dropdown') {
            <div class="no_border">
              <p-dropdown
                formControlName="option_id"
                [options]="prefrences[index].options"
                optionLabel="name"
                optionValue="id"
                class="prefrence_dropdown"
                panelStyleClass="preference-panel"
                appendTo="body"
                [showClear]="false"
                [filter]="false"
                [disabled]="formDisabled">
              </p-dropdown>
            </div>
          } @else if (prefrences[index].type === 'toggle-drop') {
            <p-inputSwitch
              formControlName="bool_value"
              (onChange)="onSpecToggle($event, index, op, data)"
              [disabled]="formDisabled"></p-inputSwitch>
          }
        </li>
      }
    </ul>
    @if (canEditPreferences) {
      <div class="btn_full">
        <p-button
          class="btn primary"
          type="submit"
          label="{{ 'Continue' | translate }}"
          [disabled]="formDisabled" />
      </div>
    }
  </form>
</div>

<p-overlayPanel #op (onHide)="onOverlayHide()">
  @if (currentSpecIndex !== null && prefrences[currentSpecIndex]) {
    <div class="speci_wp">
      <div class="title">
        <h2>{{ 'SPECIFICATIONS' | translate }}</h2>
      </div>
      <div class="main_box">
        <ul>
          @for (data of prefrences[currentSpecIndex].options; track $index; let index = $index) {
            <li>
              <div class="lt">
                <h4>{{ data.name }}</h4>
                <p>{{ data.description }}</p>
              </div>
              <div class="rt">
                <input
                  type="text"
                  logibidsTwoNumberOnly
                  pInputText
                  placeholder="00"
                  [formControl]="getOptionValueControl(currentSpecIndex, data.id)"
                  [disabled]="formDisabled" />
                <p>{{ data.quantity_type }}</p>
              </div>
            </li>
          }
        </ul>
      </div>
      <div class="btn_full">
        <p-button
          class="btn primary"
          label="{{ 'save' | translate }}"
          (click)="onSpecSave(op)"
          [disabled]="formDisabled" />
      </div>
    </div>
  }
</p-overlayPanel>
